import React, { useRef } from 'react';
import style from './index.module.less';
import { CommonBackContent } from '@/components/Layouts/CommonBackContent';
import { message } from 'antd';
import Image from 'next/image';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'next-i18next';

const Index: React.FC<any> = () => {
  const { t } = useTranslation('common');
  const { isMobile } = useConfigProvider();
  const cpHtml = (url: string) => {
    let oInput = document.createElement('input');
    oInput.value = `<a href="https://www.erasa.net/" target="_blank" rel="nofollow"><img style="max-width: 100%" alt='Erasa' src="${url}"></a>`;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand('Copy');
    oInput.remove();
    message.success('Content to copy to clipboard');
  };
  const download = async (curl: any) => {
    try {
      const response = await fetch(`/n-api/download-image?url=${curl}`);
      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Erasa.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      message.success('download is successful');
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };
  return (
    <div className={style.container}>
      <div
        className={style.head}
        style={{
          backgroundImage: isMobile ? `url("/images/dmca/dmca-bg-m.webp")` : `url("/images/dmca/dmca-bg.webp")`,
        }}
      >
        <h1> {t('DMCA Badges')}</h1>
        <h2>
          {t(
            'Click the image to get the code and add it to your profile, or download the image to include in your content. Prevent unauthorized use and protect your rights.',
          )}
        </h2>
      </div>
      <CommonBackContent>
        <ul className={style.list}>
          <li>
            <div>
              <Image
                layout="responsive"
                width={553}
                height={314}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-1.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-1.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-1.png')}>
                {t('Download')}
              </div>
            </div>
          </li>

          <li>
            <div>
              <Image
                layout="responsive"
                width={553}
                height={314}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-2.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-2.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-2.png')}>
                {t('Download')}
              </div>
            </div>
          </li>

          <li>
            <div>
              <Image
                layout="responsive"
                width={553}
                height={314}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-3.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-3.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-3.png')}>
                {t('Download')}
              </div>
            </div>
          </li>

          <li>
            <div>
              <Image
                layout="responsive"
                width={553}
                height={314}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-4.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-4.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-4.png')}>
                {t('Download')}
              </div>
            </div>
          </li>

          <li className={style.else}>
            <div>
              <Image
                layout="responsive"
                width={186}
                height={186}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-5.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-5.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-5.png')}>
                {t('Download')}
              </div>
            </div>
          </li>

          <li className={style.else}>
            <div>
              <Image
                layout="responsive"
                width={186}
                height={186}
                src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-6.png"
                alt="Erasa.net Protection"
              ></Image>
            </div>
            <div>
              <div onClick={() => cpHtml('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-6.png')}>
                {t('Copy Html')}
              </div>
              <div onClick={() => download('https://res-front.pumpsoul.com/prod-erasa/image/dmca-protect/dmca-6.png')}>
                {t('Download')}
              </div>
            </div>
          </li>
        </ul>
      </CommonBackContent>
    </div>
  );
};

export default Index;
